import { APIResponseError } from '../httpClient';

export function isEnglishIqTerminalSessionError(error: unknown): boolean {
  return error instanceof APIResponseError && error.status === 400;
}
